import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { ButtonLink } from './ButtonLink';
import { contact, QUOTE_PATH } from '../../data/site';
interface QuoteBannerProps {
  title?: string;
  text?: string;
}
export function QuoteBanner({
  title = 'Planning a road, water or building project?',
  text = 'Tell us about the scope, location and timeline, and our team will contact you to discuss the work.'
}: QuoteBannerProps) {
  return <section aria-labelledby="quote-banner-title" className="relative overflow-hidden bg-brand-action" data-id="element-498" data-mp="2uoidfhaubybe">
      <div className="clip-slant-l absolute inset-y-0 right-0 hidden w-[40%] bg-charcoal lg:block" aria-hidden="true" data-id="element-499" data-mp="2zm1oy9g5lwzn" />
      <div className="relative mx-auto grid max-w-site gap-8 px-5 py-16 md:px-8 md:py-20 lg:grid-cols-[1.3fr_1fr] lg:items-center" data-id="element-500" data-mp="2kw2sqc85svmt">
        <div data-id="element-501" data-mp="3dmci5j4xrnnz">
          <h2 id="quote-banner-title" className="font-display text-[40px] font-extrabold uppercase leading-[0.92] text-white md:text-[56px]" data-id="element-502" data-mp="3dljhmzwkluea">
            {title}
          </h2>
          <p className="mt-4 max-w-xl text-lg leading-relaxed text-white" data-id="element-503" data-mp="200c9ti638p0y">{text}</p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row lg:justify-end lg:pl-12" data-id="element-504" data-mp="1v22gze7u60ii">
          <ButtonLink to={QUOTE_PATH} variant="dark" size="lg" data-id="element-505" data-mp="29qp3bzvvrsj8">
            Request a Quote
          </ButtonLink>
          <ButtonLink to={contact.phone.href} variant="outline" size="lg" ariaLabel={`Call ${contact.phone.display}`} data-id="element-506" data-mp="24y5hkfn1hr3c">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-507" data-mp="2isev56tocthj" />
            {contact.phone.display}
          </ButtonLink>
        </div>
      </div>
    </section>;
}